import { saveAs } from 'file-saver';
import JsZip from 'jszip';
import JSZipUtils from 'jszip-utils';
import React, { Component } from 'react';
import {
  Cell, FontIcon, Grid, LinearProgress, List,
  ListItem, Button, SelectField
} from 'react-md';
import { browserHistory } from 'react-router';
import ApiRequestService from '../component/ApiRequestService';
//import CourseDashboardBarChart from '../component/CourseDashboardBarChart';
import BarChart from '../component/BarChartCustom';
import ButtonDashboard from '../component/ButtonDashboard';
import CopyQuizDialog from '../component/CopyQuizDialog';
import CopyAllQuizDialog from '../component/CopyAllQuizDialog';
import LoadingSpinner from '../component/LoadingSpinner';
import QuizListWidgetCourses from '../component/QuizListWidgetCourses';
import SectionListWidget from '../component/SectionListWidget';
import SecureShow from '../component/SecureShow';
//CSS Imports
import '../css/Dashboard.css';
import HelpText from '../lib/help-text';
import { AppProperties } from '../common/function';
import ImportAssignmentFromSemester from "../component/ImportAssignmentFromSemester"
import CreateNewAssignment from './CreateNewAssignment';
import AssignmentDetailModal from './AssignmentMatrix/Modal/AssignmentDetailModal';


//Get all Quizes for a Course
const getQuizData = (req_course_id) =>{
  const payload = {
    course_id: parseInt(req_course_id, 10)
  };

  return new Promise(function(resolve, reject) {
    ApiRequestService({
      method: 'post',
      url: '/getAllQuiz',
      data: payload
    })
      .then(res => {
        if (res.data !== undefined && res.data !== null && 
          res.data.data !== undefined && res.data.data !== null && 
          res.data.data.quizes_list !== undefined &&
          res.data.data.quizes_list !== null &&
          res.data.data.quizes_list.length > 0
        ) {
          return resolve(res.data.data.quizes_list);
        } else {
          console.error('Quiz Data Empty');
          let emptyArray = [];
          return resolve(emptyArray);
        }
      })
      .catch(error => {
        console.error('Error When Retriving Quiz Details ', error);
        reject(error, null);
      });
  });
}


export const getMQTReportBlobData = async(reportLink, id, jsZip, quizName, sectionName)=>{
  return new Promise(async(resolve, reject) => {
    const iFrameID = `hiddenDownloader_${id}`
      
    var iframe = document.createElement('iframe');
    iframe.id = iFrameID;
    iframe.style.visibility = 'hidden';
    document.body.appendChild(iframe);
      
  
      //Set the URL to Iframe
      iframe.src = reportLink;
      const timerID = setInterval(() =>{
        var link = document.getElementById(iFrameID).contentWindow.document.getElementById('view-non-graded-answers');
        if(link){
          link.click();
        }
        let numberOfCSVLinks;
        if(document.getElementById(iFrameID).contentWindow.document.getElementById("nonGradedQuestions")){
          if(document.getElementById(iFrameID).contentWindow.document.getElementById("csv-download-link-popup")){
            numberOfCSVLinks = document.getElementById(iFrameID).contentWindow.document.querySelectorAll("#csv-download-link-popup");
          }else{
            clearInterval(timerID);
            document.body.removeChild(iframe);
            resolve("No Data");
          } 
        }
        if(numberOfCSVLinks && numberOfCSVLinks != null && numberOfCSVLinks.length > 0){
          clearInterval(timerID);
          for (let CSVindex = 0; CSVindex < numberOfCSVLinks.length; CSVindex++) {
            getSingleReportBlobData(numberOfCSVLinks[CSVindex].href).then((reportBlobData)=>{
              if(reportBlobData.status){
                jsZip.file(`${quizName}_${sectionName}_${numberOfCSVLinks[CSVindex].download.replace(/[/\\?%*:|"<>]/g, '_').replace(/(.csv)/g, '')}_nongraded.csv`, reportBlobData.data, {binary:true});
              }else{
                resolve(false);
              }
              if(CSVindex === (numberOfCSVLinks.length - 1)){
                document.body.removeChild(iframe);
                resolve(true);
              }
            }).catch((err)=>{
              reject(false)
            })
          }
        }
      },3000);
    });
};

export const getSingleReportBlobData = async(reportLink)=>{
  return new Promise(function(resolve, reject) {
    const timerID = setInterval(function() {
      if(reportLink){
        clearInterval(timerID);
        JSZipUtils.getBinaryContent(reportLink, function (err, data) {
          if(err) {
            reject({status: false,
              data:err}); // or handle the error
          }
          resolve({status: true,
            data:data});
       });
      }
    },3000);
  });
};

//Creates an Iframe and loads the raw data URL, gets the generated report's blob URL.
export const getReportBlobData = async(reportLink,id)=>{
 
  
    return new Promise(function(resolve, reject) {
    const iFrameID = `hiddenDownloader_${id}`
      
    var iframe = document.createElement('iframe');
    iframe.id = iFrameID;
    iframe.style.visibility = 'hidden';
    document.body.appendChild(iframe);
      

      //Set the URL to Iframe
      iframe.src = reportLink;
      const timerID = setInterval(function(){
        console.log("reportLink",reportLink);
        const blobHref = document.getElementById(iFrameID).contentWindow.document.getElementById("csv-download-link");
        if(document.getElementById(iFrameID).contentWindow.document.getElementById("raw-data-table")){
          const tableData = document.getElementById(iFrameID).contentWindow.document.getElementById("raw-data-table").innerHTML;
          if(tableData.includes("No Data")){
            clearInterval(timerID);
            document.body.removeChild(iframe);
            resolve("No Data");
          }
        }

        if(blobHref){
          clearInterval(timerID);
          JSZipUtils.getBinaryContent(document.getElementById(iFrameID).contentWindow.document.getElementById("csv-download-link"), function (err, data) {
            window.URL.revokeObjectURL(document.getElementById(iFrameID).contentWindow.document.getElementById("csv-download-link").href) 
            document.body.removeChild(iframe);
            if(err) {
              reject(err); // or handle the error
            }
            resolve(data);
         });
        }
      },3000);
    });
};

export const getReportBlobDataNonGraded = async(reportLink,id)=>{
 
  return new Promise(function(resolve, reject) {
  const iFrameID = `hiddenDownloader_${id}`
    
  var iframe = document.createElement('iframe');
  iframe.id = iFrameID;
  iframe.style.visibility = 'hidden';
  document.body.appendChild(iframe);
    

    //Set the URL to Iframe
    iframe.src = reportLink;
    const timerID = setInterval(function(){
      console.log("reportLink",reportLink);
      let blobHref;
      var link = document.getElementById(iFrameID).contentWindow.document.getElementById('view-non-graded-answers');
      if(link){
        link.click();
      }
      let numberOfCSVLinks;
      if(document.getElementById(iFrameID).contentWindow.document.getElementById("nonGradedQuestions")){
        if(document.getElementById(iFrameID).contentWindow.document.getElementById("csv-download-link-popup") && document.getElementById(iFrameID).contentWindow.document.getElementById("csv-download-link-non-graded") && document.getElementById(iFrameID).contentWindow.document.getElementById("data-present-non-graded")){
          numberOfCSVLinks = document.getElementById(iFrameID).contentWindow.document.querySelectorAll("#csv-download-link-popup"); 
          blobHref = document.getElementById(iFrameID).contentWindow.document.getElementById("csv-download-link-non-graded");
        }else if(document.getElementById(iFrameID).contentWindow.document.getElementById("csv-download-link-popup")){
          numberOfCSVLinks = document.getElementById(iFrameID).contentWindow.document.querySelectorAll("#csv-download-link-popup");
        }else if(document.getElementById(iFrameID).contentWindow.document.getElementById("csv-download-link-non-graded") && document.getElementById(iFrameID).contentWindow.document.getElementById("data-present-non-graded")){
          blobHref = document.getElementById(iFrameID).contentWindow.document.getElementById("csv-download-link-non-graded");
        }else{
          clearInterval(timerID);
          document.body.removeChild(iframe);
          resolve({data:"No Data",MQTData:[]});
        } 
      }
      if(blobHref && numberOfCSVLinks && numberOfCSVLinks != null && numberOfCSVLinks.length > 0){
        clearInterval(timerID);
        JSZipUtils.getBinaryContent(document.getElementById(iFrameID).contentWindow.document.getElementById("csv-download-link-non-graded"), function (err, data) {
          window.URL.revokeObjectURL(document.getElementById(iFrameID).contentWindow.document.getElementById("csv-download-link-non-graded").href) 
          document.body.removeChild(iframe);
          if(err) {
            reject(err); // or handle the error
          }
          resolve({data:data,MQTData:numberOfCSVLinks});
       });
      }else if(numberOfCSVLinks && numberOfCSVLinks != null && numberOfCSVLinks.length > 0){
        resolve({data:"No Data",MQTData:numberOfCSVLinks});
      }else if(blobHref){
        clearInterval(timerID);
        JSZipUtils.getBinaryContent(document.getElementById(iFrameID).contentWindow.document.getElementById("csv-download-link-non-graded"), function (err, data) {
          window.URL.revokeObjectURL(document.getElementById(iFrameID).contentWindow.document.getElementById("csv-download-link-non-graded").href) 
          document.body.removeChild(iframe);
          if(err) {
            reject(err); // or handle the error
          }
          resolve({data:data,MQTData:[]});
       });
      }
    },3000);
  });
};

export const getReportBlobTestData = async(reportLink,id)=>{
 
  
  return new Promise(function(resolve, reject) {
  const iFrameID = `hiddenDownloader_${id}`
    
  var iframe = document.createElement('iframe');
  iframe.id = iFrameID;
  iframe.style.visibility = 'hidden';
  document.body.appendChild(iframe);
    

    iframe.src = reportLink;
    const timerID = setInterval(function(){
      console.log("reportLink",reportLink);
      const blobHref = document.getElementById(iFrameID).contentWindow.document.getElementById("csv-download-link");
      if(document.getElementById(iFrameID).contentWindow.document.getElementById("raw-data-table")){
        const tableData = document.getElementById(iFrameID).contentWindow.document.getElementById("raw-data-table").innerHTML;
        if(tableData.includes("No Data")){
          clearInterval(timerID);
          document.body.removeChild(iframe);
          resolve("No Data");
        }
      }

      if(blobHref){
        clearInterval(timerID);
        JSZipUtils.getBinaryContent(document.getElementById(iFrameID).contentWindow.document.getElementById("csv-download-link"), function (err, data) {
          window.URL.revokeObjectURL(document.getElementById(iFrameID).contentWindow.document.getElementById("csv-download-link").href) 
          document.body.removeChild(iframe);
          if(err) {
            reject(err); 
          }
          resolve(data);
       });
      }
    },3000);
  });
};


const deepCopyQuizArray = (argQuizList) =>{
  
  return argQuizList.map((value)=>{
   
    let quizData = {quiz_id:value.quiz_id,quiz_type:value.quiz_type,title:value.title};
    return quizData;
  });
}
const pad = (num) =>  {
  return ("0"+num).slice(-2);
}

const hhmmss =  (secs) => {
var minutes = Math.floor(secs / 60);
secs = secs%60;
var hours = Math.floor(minutes/60)
minutes = minutes%60;
return `${pad(hours)}:${pad(minutes)}:${pad(Math.floor(secs))}`;
}

const scoreRangeLabel = (tooltipItem, data) => {
  
  var label = tooltipItem?.label;

  if (label) {
      label += ': ';
  }
  label += Math.round(tooltipItem.raw * 100) / 100;

  return "No. of students attempted : " + label;
}


const getComletionTimeLabel = (tooltipItem, data) => {
  var label = tooltipItem?.label;

  if (label) {
      label += ': ';
  }
  console.debug("tooltipItem>>??", tooltipItem, data)
  label += Math.round(tooltipItem.raw * 100) / 100;
  return "Median Completion Time : " + hhmmss(tooltipItem.raw);
}


const getCompletionPercentLabel = (tooltipItem, data) => {
  console.debug("data>>??", data, tooltipItem)
  var label = tooltipItem?.label;

  if (label) {
      label += ': ';
  }
  label += Math.round(tooltipItem.raw * 100) / 100;

  return "Avg % of questions correctly answered:"+label;
}

const buildGraphData = (res,valueName) =>{
  let quizLabel = [];
  let quizData = [];
  if(res !== undefined && res !== null && 
    res.data !== undefined &&  res.data !== null &&
    res.data.data !== undefined &&  res.data.data !== null &&
    res.data.data.course_quiz_percentage !== undefined &&  
    res.data.data.course_quiz_percentage !== null){

      var tempCourseDetails = res.data.data.course_quiz_percentage;
      
      for(var i = 0; i < tempCourseDetails.length;i++ ){
        quizLabel.push(tempCourseDetails[i].quiz_name);
        quizData.push(tempCourseDetails[i][valueName]);
      }

      return {'label':quizLabel,'data':quizData};
  }

  return null;
}
const ErrorIcon = () => <FontIcon style={{color:"red"}} >error</FontIcon>;
const SuccessIcon = () => <FontIcon style={{color:"green"}} >check</FontIcon>;

export const GeneratingReportLoader = ({value,status}) => {
  
    return <div>
              <div className="consolidated-report-progress-container">
                  <div className="md-display-1">Please wait. This operation will take several minutes to complete.</div>
                  <LinearProgress value={value} determinate style={{ height: 10 ,width:"95%"}}  />
                  <List className="md-paper md-paper--1 consolidated-report-progress-container-list-container">
                      <ListItem primaryText="Your report is being generated!"  />
                      {
                        status.map(stat=>{
                        return <ListItem primaryText={stat.quizName} rightIcon={stat.status === 1 ?<SuccessIcon />:stat.status === -1 ?<ErrorIcon/>:null} />
                        })
                      }
                  </List>
              </div>
              
           </div>
  
}

export default class CoursesDashboard extends Component {
  helpTextModel = new HelpText();
  appProperties = AppProperties();
  baseFolder = this.appProperties.baseFolder;

  constructor(props) {
    super(props);
    console.debug('this.props',(this.props));


    this.state = {
      courseListArray: [],
      courses: [],
      selectedCourseID: 0,
      selectedCourseName:'',
      selectedCourseIndex: -1,
      loading: true,
      quizList:[],
      showCourseGraph:true,
      showQuizCopyDialog:false,
      showQuizCopyAllDialog:false,
      generatingQuizReports:false,
      reportGenerationProgress:0,
      reportGenerationStatus:[],
      loadingGraph:true,
      noCourseInSemester:false,
      downloadListArray: [{title:"Download Selected Graded",id:0},{title:"Download Selected Non-Graded", id:1},{title:"Download Selected Graded & Non-Graded", id:1}],
      downloadAllListArray: [{title:"Download All Graded Data",id:0},{title:"Download All Non-Graded Data", id:1},{title:"Download All Graded & Non-Graded Data", id:1}],
      selectedAssignmentList : {},
      editAssignmentMode: false,
      editAssignment: null,
      savedAssignment: null,
    };

    this.createQuizClick = this.createQuizClick.bind(this);
  }

  // Insert into SlectedAssignmentArray
  assignmentSelectHandle = (assignment,select,isTotal,page) =>{
    var newAssignment = {...this.state.selectedAssignmentList};
    // Insert assignment
    if(select){
      if(newAssignment[page] === undefined){
        newAssignment[page] = [];
      }
      if(!isTotal){
        newAssignment[page].push(assignment);
      }
      else{
        newAssignment[page] = [...assignment];
      }
    }
    // Remove assignment
    else{
      if(!isTotal && Object.keys(newAssignment[page]).length > 1){
        newAssignment[page].forEach((item,index)=>{
          if(assignment.quiz_id === item.quiz_id){
            newAssignment[page].splice(index,1);
          }
        });
      }
      else{
        delete newAssignment[page];
      }
    }
    this.setState({
      ...this.state,
      selectedAssignmentList : newAssignment
    });
    return true;
  };

  removeAllSelectedAssignment = ()=>{
    this.setState({
      ...this.state,
      selectedAssignmentList : []
    });
  };

  //Create an Array of Courlist for Select Box
  makeCourselistArray(courseObject, index) {
    return {
      key: 'KEY_' + index,
      title: courseObject?.is_lti_enabled ? `${courseObject.course_name} (LTI Course)` : courseObject.course_name,
      isLTICourse: courseObject?.is_lti_enabled,
      value: courseObject.course_id
    };
  }
  addBreadCrumbs = () => {
    console.debug('Course AddBreadCrumbs');
    if(this.props.replaceBreadCrumb !== undefined){
      this.props.replaceBreadCrumb();
    }
  };

  componentWillUpdate() {
    this.addBreadCrumbs();
  }

  //API Call to Get Course Data
  getGraphData = (courseID) =>{

    this.setState({loadingGraph:true});
    let parent = this;
    const payload = {
      course_id: parseInt(courseID, 10)
    };

    return  new Promise((resolve, reject) =>  {
      
      let promises = [];
      promises.push(ApiRequestService({
                                    method: 'post',
                                    url: '/getCourseGraph',
                                    data: payload
                                  }));

      promises.push(ApiRequestService({
                                            method: 'post',
                                            url: '/getCourseMedianGraph',
                                            data: payload
                                        }));

      Promise.all(promises).then(results =>{

        let getCourseGraphResp        = buildGraphData(results[0],'quiz_percentage');
        let getCourseMedianGraphResp  = buildGraphData(results[1],'quiz_median_time');

        resolve({'attemptPercentage':getCourseGraphResp,'medianData':getCourseMedianGraphResp});
      }).catch(function(err) {

        reject(err);
      }).finally(function(){
        parent.setState({loadingGraph:false});
      });

      
    });
  }

  promisedSetState = (newState) => new Promise(resolve => this.setState(newState, resolve));
  
  generateConsolidatedReport = async(quizes,courseName,dropIndex)=>{
    const totalQuizes = quizes.length;
    let completedQuizes = 0;
    let DropIndex = dropIndex;
    let appProperties = AppProperties();

    let isOrg = window.location.hostname.includes("org");
    console.debug("appProperties.appURL", appProperties.appURL)

    let appURL = appProperties.appURL;

    if (isOrg) {
      appURL = appURL.replace(".com", ".org")
    }

    console.debug("appURL -----", appURL)

    return new Promise(async (resolve,reject)=>{
      let jsZip = JsZip();
      //loop through quizes
      if(quizes && quizes.length>0){
        
        let promisesArr = [];

        for (let index = 0; index < quizes.length; index++) {
          const quiz = quizes[index];

          try{
            let reportBlobData;
            if(quiz.quiz_type == 0){
                  // removed &section_id=${quiz.section_Id} from query string
                  let reportLink = `${appURL}quizScore?qname=${quiz.quiz_name}&quiz_id=${quiz.quiz_id}&course_id=${quiz.course_id}&static=0`;
                  
                  if(DropIndex == 0){
                    /* reportBlobData = await getReportBlobData(reportLink,`${quiz.quiz_id}_${quiz.section_Id}`);
                    jsZip.file(`${quiz.quiz_name.replace(/[/\\?%*:|"<>]/g, '_')}_${quiz.section_name.replace(/[/\\?%*:|"<>]/g, '-')}_Graded.csv`, reportBlobData, {binary:true}); */
                    let promise = getReportBlobData(reportLink,`${quiz.quiz_id}_${quiz.section_Id}`);
                    promisesArr.push(promise);
                  }else if(DropIndex == 1){
                    /* let reportMRBlobData = await getReportBlobDataNonGraded(reportLink,`${quiz.quiz_id}_${quiz.section_Id}`);
                    reportBlobData = reportMRBlobData.data
                    if(reportBlobData !== "No Data"){
                      jsZip.file(`${quiz.quiz_name.replace(/[/\\?%*:|"<>]/g, '_')}_${quiz.section_name.replace(/[/\\?%*:|"<>]/g, '-')}_Non-Graded.csv`, reportBlobData, {binary:true});
                    }
                    if (reportMRBlobData.MQTData && reportMRBlobData.MQTData.length > 0){
                         try {
                            await getMQTReportBlobData(reportLink, `${quiz.quiz_id}_${quiz.section_Id}`, jsZip, quiz.quiz_name.replace(/[/\\?%*:|"<>]/g, '_'), quiz.section_name.replace(/[/\\?%*:|"<>]/g, '-'));
                            reportBlobData = "Data Present";
                         } catch(err) {
                           console.log("Error", err);
                         }      
                    } */
                      let promise = await getReportBlobDataNonGraded(reportLink,`${quiz.quiz_id}_${quiz.section_Id}`);
                      promisesArr.push(promise);
                  }else if(DropIndex == 2){
                    /* let reportMRBlobData = await getReportBlobDataNonGraded(reportLink,`${quiz.quiz_id}_${quiz.section_Id}`);
                    reportBlobData = reportMRBlobData.data
                    if(reportBlobData !== "No Data"){
                      jsZip.file(`${quiz.quiz_name.replace(/[/\\?%*:|"<>]/g, '_')}_${quiz.section_name.replace(/[/\\?%*:|"<>]/g, '-')}_Non-Graded.csv`, reportBlobData, {binary:true});
                    }
                    if (reportMRBlobData.MQTData && reportMRBlobData.MQTData.length > 0){
                         try {
                            await getMQTReportBlobData(reportLink, `${quiz.quiz_id}_${quiz.section_Id}`, jsZip, quiz.quiz_name.replace(/[/\\?%*:|"<>]/g, '_'), quiz.section_name.replace(/[/\\?%*:|"<>]/g, '-'));
                         } catch(err) {
                           console.log("Error", err);
                         }      
                    }
                    reportBlobData = await getReportBlobData(reportLink,`${quiz.quiz_id}_${quiz.section_Id}`);
                    jsZip.file(`${quiz.quiz_name.replace(/[/\\?%*:|"<>]/g, '_')}_${quiz.section_name.replace(/[/\\?%*:|"<>]/g, '-')}_Graded.csv`, reportBlobData, {binary:true});
                    if (reportMRBlobData.MQTData && reportMRBlobData.MQTData.length > 0){
                      reportBlobData = "Data Present"
                    } */
                    let promise = getReportBlobDataNonGraded(reportLink,`${quiz.quiz_id}_${quiz.section_Id}`);
                    promisesArr.push(promise);
                  }

            }else{
                  // removed &section_id=${quiz.section_Id} from query string
                  let reportLink = `${appURL}testScore?qname=${quiz.quiz_name}&quiz_id=${quiz.quiz_id}&course_id=${quiz.course_id}&static=0`;
                  /* reportBlobData = await getReportBlobTestData(reportLink,`${quiz.quiz_id}_${quiz.section_Id}`);
                  jsZip.file(`${quiz.quiz_name.replace(/[/\\?%*:|"<>]/g, '_')}_${quiz.section_name.replace(/[/\\?%*:|"<>]/g, '-')}_Test-Data.csv`, reportBlobData, {binary:true}); */

                  let promise = getReportBlobTestData(reportLink,`${quiz.quiz_id}_${quiz.section_Id}`);
                  promisesArr.push(promise)
            }

            /* completedQuizes++;
            let status = 1
            console.log("reportBlobData",reportBlobData);
            
            if(reportBlobData === "No Data"){
              status = -1
            }
            
            
            let copy = [...this.state.reportGenerationStatus]
            copy.splice(index, 1, {quizName:copy[index].quizName,status:status})
            this.setState({
              reportGenerationProgress:((completedQuizes/totalQuizes)*100),
              reportGenerationStatus:[...copy]
            }); */
          }catch(err){
            console.log("Error",err);
          }      
        }

        function timeout(ms) {
          return new Promise(resolve => setTimeout(resolve, ms));
        }

        console.debug("promisesArr>>>>", promisesArr)

        Promise.all(promisesArr).then(async (dataArr) => {
          for (let index = 0; index < dataArr.length; index++) {
            let quiz = quizes[index];
            let mainData = dataArr[index];

            let reportLink = `${appURL}quizScore?qname=${quiz.quiz_name}&quiz_id=${quiz.quiz_id}&course_id=${quiz.course_id}&static=0`;

            if (quiz.quiz_type === 1) { // Test
              jsZip.file(`${quiz.quiz_name.replace(/[/\\?%*:|"<>]/g, '_')}_${quiz.section_name.replace(/[/\\?%*:|"<>]/g, '-')}_Test-Data.csv`, mainData, {binary:true});
            } else { // Quiz
              if (DropIndex === 0) {
                jsZip.file(`${quiz.quiz_name.replace(/[/\\?%*:|"<>]/g, '_')}_${quiz.section_name.replace(/[/\\?%*:|"<>]/g, '-')}_Graded.csv`, mainData, {binary:true});
              } else if (DropIndex === 1) {
                let reportMRBlobData = mainData;
                let reportBlobData = reportMRBlobData.data
                if(reportBlobData !== "No Data"){
                  jsZip.file(`${quiz.quiz_name.replace(/[/\\?%*:|"<>]/g, '_')}_${quiz.section_name.replace(/[/\\?%*:|"<>]/g, '-')}_Non-Graded.csv`, reportBlobData, {binary:true});
                }
                if (reportMRBlobData.MQTData && reportMRBlobData.MQTData.length > 0){
                      try {
                        await getMQTReportBlobData(reportLink, `${quiz.quiz_id}_${quiz.section_Id}`, jsZip, quiz.quiz_name.replace(/[/\\?%*:|"<>]/g, '_'), quiz.section_name.replace(/[/\\?%*:|"<>]/g, '-'));
                        mainData = "Data Present";
                      } catch(err) {
                        console.log("Error", err);
                      }      
                }
              } else if (DropIndex === 2) {
                let reportMRBlobData = mainData;
                let reportBlobData = reportMRBlobData.data
                if(reportBlobData !== "No Data"){
                  jsZip.file(`${quiz.quiz_name.replace(/[/\\?%*:|"<>]/g, '_')}_${quiz.section_name.replace(/[/\\?%*:|"<>]/g, '-')}_Non-Graded.csv`, reportBlobData, {binary:true});
                }
                if (reportMRBlobData.MQTData && reportMRBlobData.MQTData.length > 0){
                      try {
                        await getMQTReportBlobData(reportLink, `${quiz.quiz_id}_${quiz.section_Id}`, jsZip, quiz.quiz_name.replace(/[/\\?%*:|"<>]/g, '_'), quiz.section_name.replace(/[/\\?%*:|"<>]/g, '-'));
                      } catch(err) {
                        console.log("Error", err);
                      }      
                }
                reportBlobData = await getReportBlobData(reportLink,`${quiz.quiz_id}_${quiz.section_Id}`);
                jsZip.file(`${quiz.quiz_name.replace(/[/\\?%*:|"<>]/g, '_')}_${quiz.section_name.replace(/[/\\?%*:|"<>]/g, '-')}_Graded.csv`, reportBlobData, {binary:true});
                if (reportMRBlobData.MQTData && reportMRBlobData.MQTData.length > 0){
                  mainData = "Data Present"
                }
              }
            }

            completedQuizes++;
            let status = 1
            if(mainData === "No Data"){
              status = -1
            }
            
            let copy = [...this.state.reportGenerationStatus]
            copy.splice(index, 1, {quizName:copy[index].quizName,status:status})

            await this.promisedSetState({
              reportGenerationProgress:((completedQuizes/totalQuizes)*100),
              reportGenerationStatus:[...copy]
            })

            await timeout(500)
          }

          if(DropIndex == 0){
            jsZip.generateAsync({type: "blob"}).then(zipFile=>{
              saveAs(zipFile, `${courseName}_conslidated_graded.zip`)
            }).finally(()=>{
              resolve(true);
            });
          }else if(DropIndex == 1){
            jsZip.generateAsync({type: "blob"}).then(zipFile=>{
              saveAs(zipFile, `${courseName}_conslidated_non-graded.zip`)
            }).finally(()=>{
              resolve(true);
            });
          }else if(DropIndex == 2){
            jsZip.generateAsync({type: "blob"}).then(zipFile=>{
              saveAs(zipFile, `${courseName}_conslidated_graded_&_non-graded.zip`)
            }).finally(()=>{
              resolve(true);
            });
          }
        })
      }else{
        //TODO show Error Message
        resolve(true);
      }
    });
    
  }

  //Gets the score for all the quizes of all the sections, in the current course.
   createConsolidatedReport=(_,index,data=null)=>{
     //ToDo - Notify user that this could take a while
    //Get current course
    //Get All Quizes under the course
      this.setState({generatingQuizReports:true,reportGenerationProgress:0,reportGenerationStatus:[]});
    if(this.state.selectedCourseID){
      var quizes = (data == null )? [] : [...data];
      if(data == null){
        Object.keys(this.state.selectedAssignmentList).forEach((key)=>{
          quizes = quizes.concat(this.state.selectedAssignmentList[key]);
        });
      }
      quizes.forEach((item,index)=>{
        quizes[index].section_name = quizes[index].section_name[0];
      });

       this.setState({reportGenerationStatus:quizes.map(quiz=>{
        return {quizName:`SECTION - ${quiz.section_name} and QUIZ - ${quiz.quiz_name}`,status:0
      }})})
        this.generateConsolidatedReport(quizes,this.state.courseListArray[this.state.selectedCourseIndex].title,index).finally(()=>{
           this.setState({generatingQuizReports:false,selectedAssignmentList:[]});
          })
      }
     
  }
    
   

   componentWillMount() {
    

      
       
    ApiRequestService({
      method: 'post',
      url: '/getAllCourses'
    })
      .then( async (res) => {
        if (
          res.data.data.course_names !== undefined &&
          res.data.data.course_names !== null
        ) {
          let courseArray = res.data.data.course_names.map(
            this.makeCourselistArray
          );
          console.debug('courseArray', JSON.stringify(courseArray));
          var selectedIndex = 0;
          if(this.props.location!== undefined &&
            this.props.location.query !== undefined &&
            this.props.location.query.course_indx !== undefined){
              selectedIndex = this.props.location.query.course_indx;
          }
          this.setState({
            loading: false,
            courses: res.data.data.course_names,
            courseListArray: courseArray,
            selectedCourseID: courseArray[selectedIndex].value,
            selectedCourseName:courseArray[selectedIndex].title,
            selectedCourseIndex: selectedIndex,
          });  
          let graphDataObject = await this.getGraphData(courseArray[selectedIndex].value)
            this.setState({
              graphData:graphDataObject
            });     
        } else {
          (this.appProperties.schoolMode?(this.appProperties.currentUserData.role === 1?
            alert('No Standards found. Please ask your Administrator to associate you with a Standard and Section.')
            :
            alert('No Standards found. Please add a new Standard and create Sections within it.')
            ) 
            :
            (
             this.setState({
              loading: false,
              noCourseInSemester: true,
             })
            ) 
          )
          
        }
      })
      .catch(error => {
        console.error(error);
      });     
  }

  onSectionClick = (sectionID, sectionName) => {
    console.debug(
      'this.state.selectedCourseIndex' + this.state.selectedCourseIndex
    );
    console.debug('this.state.courses', this.state.courses, this.state.selectedCourseIndex);
    
    //let courseName = this.state.courseListArray[this.state.selectedCourseIndex]
    //  .title;
    browserHistory.push(
      this.baseFolder +
        'sectionsDashboard?section_id=' +
        sectionID +
        '&course_id=' +
        this.state.selectedCourseID +
        '&course_name=' +
        this.state.selectedCourseName +
        '&section_name=' +
        sectionName +
        '&course_indx=' +
        this.state.selectedCourseIndex +
        '&is_lti_enabled=' +
        this.state.courses[this.state.selectedCourseIndex].is_lti_enabled
    );
  };

  onCourseChange = async (
    argSelectedCourseID,
    index,
    event,
    courseObject // eslint-disable-line no-unused-vars
  ) => {
    // console.debug("onCourseChange index"+index);
    this.setState({
      selectedCourseID: argSelectedCourseID,
      selectedCourseIndex: index,
      selectedCourseName:this.state.courseListArray[index].title,
    });
    let graphDataObject = await this.getGraphData(argSelectedCourseID);
    this.setState({
      graphData:graphDataObject,
    });
    this.setState({showCourseGraph:true});
};

  /* onDownloadChange(_,index)  {
    switch(index){
      case 0:
        console.log("index", index);
        break;
      case 1:
        console.log("index", index);
        this.createConsolidatedReport(index);
        break;
      default:
        console.log("index", index);
    }
}; */
  createQuizClick() {
    if (this.state.selectedCourseID !== 0) {
      browserHistory.push(
        this.baseFolder + 'QuizCreation?course_id=' + this.state.selectedCourseID+
        '&course_indx=' + this.state.selectedCourseIndex + '&course_name=' +this.state.selectedCourseName 
        + '&is_lti_enabled=' + this.state.courses[this.state.selectedCourseIndex].is_lti_enabled
      );
    } else {
      alert('Please Select course');
    }
  }

  onQuizEditClick(quizObject) {
    //QuizCreation?course_id=8&section_id=16&quiz_id=558&course_name=course%20test%20102&section_name=Phy%20seesntial%20section%20101-%20fall%202018
    console.debug("quizObject", quizObject);
    // this.setState({ editAssignmentMode: true, editAssignment: quizObject });

    browserHistory.push(
      this.baseFolder +
        'QuizCreation?course_id=' +
        quizObject.course_id +
        '&quiz_id=' +
        quizObject.quiz_id +             
        '&course_indx=' + this.state.selectedCourseIndex +
        '&course_name=' +this.state.selectedCourseName +
        '&is_lti_enabled=' + this.state.courses[this.state.selectedCourseIndex].is_lti_enabled
    );
  }

  onQuizEditClose = () => {
    this.setState({ editAssignmentMode: false, editAssignment: null });
  }

  onQuizScoreClick(quizObject) {
    console.debug("quizObject>>>>", quizObject);
    var pageName = "quizScore";
    if(quizObject.quiz_type === 1){
      pageName = "testScore";
    }
    browserHistory.push(
      this.baseFolder +
      pageName + '?qname=' +
        quizObject.quiz_name +
        '&quiz_id=' +
        quizObject.quiz_id +
        '&course_id=' +
        quizObject.course_id +
        '&static=0&course_name=' +
        this.state.courseListArray[this.state.selectedCourseIndex].title +
        '&course_indx=' + this.state.selectedCourseIndex +
        '&is_anonymous=' + quizObject.is_anonymous
    );
  }
  copyQuizID = undefined;
  copyCourseID = undefined;

  onCopyQuizClick = (quizObject) => {
    console.debug("quizObject>>",quizObject)
    this.setState({showQuizCopyDialog:true});
    this.copyQuizID = quizObject.quiz_id;
  }

  onCopyAllQuizClick = (courseId) => {
    console.log("onAllQuizClick", courseId);
    this.setState({showQuizCopyAllDialog:true});
    this.copyCourseID = courseId;
  }

  onCopyQuizDialogHide = () => {
    this.setState({showQuizCopyDialog:false});
  }

  onCopyAllQuizDialogHide = () => {
    this.setState({showQuizCopyAllDialog:false});
  }

  onQuizListChanged = (argQuizList) => {
    //let quizList = JSON.parse(JSON.stringify(argQuizList));
    const quizList = [{"title":"Show Assignment Graphs",quiz_id:-1}].concat(deepCopyQuizArray(argQuizList));
    this.setState({quizList});
  }

  onQuizSelected = async(_,index) =>{
    this.setState({loadingGraph:true});
    if(index === 0){
      this.setState({showCourseGraph:true});
    }else{
      let quiz = this.state.quizList[index];
    
      if(quiz && quiz.quiz_id){
        let quizGraphData = await this.requestQuizGraphData(quiz);
        if(quizGraphData){
          this.setState({quizGraphData,showCourseGraph:false});
        }
    }
    }
    
    this.setState({loadingGraph:false});
    
  }

  requestQuizGraphData = async(quiz) =>{
    
    
    const quizGraphResp = await ApiRequestService({
                            method: 'post',
                            url: '/getQuizGraph',
                            data:{id:quiz.quiz_id,isTest:(quiz.quiz_type===1)}
                          });
    
    try{
      if(quizGraphResp && quizGraphResp.data){
        if(quizGraphResp.data.status === 0 && quizGraphResp.data.data){
            return quizGraphResp.data.data;
        }else{
          console.error(quizGraphResp.data.message)
          
        }

      }else{
        console.error("No Data Received from Server")
      }

    }catch(e){
      console.error(e);
    }

    return undefined;
  }

  onSaveAssignment = (savedAssignment) => {
    this.setState({
      savedAssignment,
    })
  }

  render() {
    if (this.state.noCourseInSemester) {
      return (
        <div>
          <div style={{width:'81%',textAlign:'center',position: "absolute",top: "40%"}}>
            <h1 style={{color:"#BB0000",fontSize:"x-large",marginBottom:"20px"}}>
              No courses found in current semester <br/>Please add courses for this semester
            </h1>
                            
            <a href='Courses'>
              <Button  primary  raised className="buttonColour" flat styel={{align:"center",minWidth:"100%"}}>Click here to create Courses</Button></a> </div>
        </div>
      )
    }
    if (this.state.generatingQuizReports){
      return <GeneratingReportLoader value={this.state.reportGenerationProgress} status={this.state.reportGenerationStatus}/>
    }
    if (this.state.loading) return <LoadingSpinner loading={true} />;

    let courseWidgets = (
        <Cell
          size={8}
          phoneSize={12}
          tabletSize={12}
          className=" noHorizondalPadding dataBox "
        >
          <Grid
            gutter={3}
            className="styleScoreDistribution noHorizondalPadding"
          >
            {
              this.state.showCourseGraph?
              [<Cell size={6} key="cellQuizScorePercentage" >
              <BarChart loading={this.state.loadingGraph} 
              graphTitleClass="graphTitleStyle"  
              getBarLabel={getCompletionPercentLabel} 
              title="Average Accuracy" 
              data={this.state.graphData !== undefined && this.state.graphData.attemptPercentage !== null?this.state.graphData.attemptPercentage.data:""}  
              label={this.state.graphData !== undefined && this.state.graphData.attemptPercentage !== null?this.state.graphData.attemptPercentage.label:""}   />             
              </Cell>,
              <Cell size={6} key="cellCompletionTime">
                <BarChart loading={this.state.loadingGraph} labelFormatter={hhmmss} getBarLabel={getComletionTimeLabel} graphTitleClass="graphTitleStyle" barLabel="Completion Time"  title="Completion Time" data={this.state.graphData !== undefined ? this.state.graphData.medianData.data : ""}  label={this.state.graphData !== undefined ? this.state.graphData.medianData.label : ""}  />             
              </Cell>]
              :
              [<Cell size={6} key="cellQuizScoreRange" >
                <BarChart showxAxesLabel={true} stepSize={1} loading={this.state.loadingGraph} getBarLabel={scoreRangeLabel} graphTitleClass="graphTitleStyle"  title="Average Accuracy Range" data={this.state.quizGraphData.scoreRangeData}  label={this.state.quizGraphData.scoreRangeLabel}   />             
              </Cell>,
              <Cell size={6} key="cellQuizTimeRange" >
                <BarChart showxAxesLabel={true} stepSize={1} loading={this.state.loadingGraph} getBarLabel={scoreRangeLabel} graphTitleClass="graphTitleStyle"  title="Completion Time Distribution" data={this.state.quizGraphData.timeRangeData}  label={this.state.quizGraphData.timeRangeLabel}   />             
              </Cell>]
            }
            
            <Cell size={6} style={{textAlign:'left',paddingLeft:'20px'}}>
              <label htmlFor="quiz-graph-dropdown" style={{
                marginRight:'20px',
                position:'relative',
                top:'-10px'
              }}>
                Pick an Assignment:
              </label>
              <SelectField id="quiz-graph-dropdown"
              placeholder="Select Assignment"
              itemLabel="title"
              itemValue="quiz_id"
              menuItems={this.state.quizList}
              onChange={this.onQuizSelected}
              defaultValue={-1}
              ></SelectField>
            </Cell>
            <Cell size={6}>
              <ul className='quiz-graph-drop-down-help'>
                <li>Move the mouse over the bars to see more details</li>
              </ul>
            </Cell>
          </Grid>
        </Cell>
    );
    let sectionWidgets = (
        <Cell
          size={4}
          phoneSize={12}
          tabletSize={12}
          className="noHorizondalPadding dataBox"
        >
          {console.debug(
            'this.state.selectedCourseID',
            this.state.selectedCourseID
          )}
          <SecureShow targetRole={1}>
            <SectionListWidget
              onClick={this.onSectionClick.bind(this)}
              course_id={this.state.selectedCourseID}
            />
          </SecureShow>
        </Cell>
    );
    let quizListWidgets = (
        <Cell
          size={12}
          phoneSize={12}
          tabletSize={12}
          className="noHorizondalPadding dataBox"
        >
          <QuizListWidgetCourses
            isLTIEnabled={this.state.courses[this.state.selectedCourseIndex].is_lti_enabled}
            onQuizEditClick={this.onQuizEditClick.bind(this)}
            onScoreClick={this.onQuizScoreClick.bind(this)}
            onCopyQuizClick={this.onCopyQuizClick}
            onCopyAllQuizClick={this.onCopyAllQuizClick}
            rowsPerPage={20}
            course_id={this.state.selectedCourseID}
            title="Assignment List"
            onQuizListChanged={this.onQuizListChanged}
            assignmentSelectHandle={this.assignmentSelectHandle}
            selectedAssignmentList={this.state.selectedAssignmentList}
            downloadListArray={this.state.downloadListArray}
            downloadAllListArray={this.state.downloadAllListArray}
            createConsolidatedReport={this.createConsolidatedReport}
            helpTextModel={this.helpTextModel}
            removeAllSelectedAssignment={this.removeAllSelectedAssignment}
            selectedCourse={this.state.courses && this.state.courses[this.state.selectedCourseIndex] ? this.state.courses[this.state.selectedCourseIndex] : null}
            selectedCourseIndex = {this.state.selectedCourseIndex}
            savedAssignment={this.state.savedAssignment}
          />
        </Cell>
    );
    let tempRowDispalyNone = { display: 'none' };
    let tempRowDispalyBlock = { display: 'block' };

    return (
      <SecureShow targetRole={1}>
      <h1 style = {{marginTop:'13px', color:'#bb0000'}}>
        {this.appProperties.schoolMode?"Standard":"Course"}  Dashboard - {this.state.courseListArray[this.state.selectedCourseIndex].title}
      </h1>
      <br/>
        <Grid gutter={1}>
      
          <label htmlFor="selectCourses" style = {{fontSize:"20px",marginTop:'13px', color:'#bb0000'}}>
          <b>{this.appProperties.schoolMode?"Pick a Standard:":"Pick a Course:"}</b></label><br/>
          <SelectField
            id="selectCourses"
            className="md-cell md-cell--4  md-cell--6-phone DashBoardSelectFieldBigClass selectFieldLeftAlign overflow-ellipsis-select"
            placeholder="Select   Course"
            itemLabel="title"
            menuItems={this.state.courseListArray}
            onChange={this.onCourseChange}
            defaultValue={this.state.selectedCourseID}
          />
          <Cell size={6} phoneSize={6} className="dashboard-button-container">
            {/* <CreateNewAssignment 
              selectedCourse={this.state.courses && this.state.courses[this.state.selectedCourseIndex] ? this.state.courses[this.state.selectedCourseIndex] : null}
              editAssignmentMode={this.state.editAssignmentMode}
              editAssignmentData={this.state.editAssignment}

              onSaveAssignment={this.onSaveAssignment}
              onQuizEditClose={this.onQuizEditClose}
            /> */}
            <ButtonDashboard
              style={
                this.state.selectedCourseID
                  ? tempRowDispalyBlock
                  : tempRowDispalyNone
              }
              onCreateQuizSelect={this.createQuizClick}
              icon="calendar_today"
              
            >
              Create New Assignment
            </ButtonDashboard>
          
            {/* <ButtonDashboard
              style={
                this.state.selectedCourseID
                  ? tempRowDispalyBlock
                  : tempRowDispalyNone
              }
              tooltipLabel ="This will process and download all raw files for the course, one file for each assignment for each section. This will take several minutes to process."
              onCreateQuizSelect={this.createConsolidatedReport}
              icon="attach_file"
            >
              {appProperties.eqmMode?"Download All Results":"Download All Raw Data"}
            </ButtonDashboard> */}
          </Cell>          

          {this.state.selectedCourseID ? 
            <Grid gutter={1}>
              {courseWidgets}
              {sectionWidgets}
              {quizListWidgets}
            </Grid>
           : ''}
        </Grid>
        <CopyQuizDialog visible={this.state.showQuizCopyDialog} onHide={this.onCopyQuizDialogHide} courses={this.state.courseListArray} quizID={this.copyQuizID}
        isLTIEnabled={this.state.courses[this.state.selectedCourseIndex].is_lti_enabled}
        isMatrix={false}
        />
            <ImportAssignmentFromSemester 
                visible={this.state.showQuizCopyAllDialog}
                onHide={this.onCopyAllQuizDialogHide}
                courseID={this.copyCourseID}
                CurrentCourses={this.state.courseListArray}
                fromMatrixPage={false}
                CurrentSelectedCourse={this.state.courses[this.state.selectedCourseIndex]}
            />
       
      </SecureShow>
    );
  }
}
